import type { BaseUsecase } from '@usecases/base-usecase';
import type { Agent } from '@entities/user';
import type { TeammateAvailabilityChangePayload } from '@main/event-listeners/payloads/bus-agent-list.payload';
import { RepositoryFactory } from '@main/factories/repository.factory';

export interface TeammateAvailabilityChangedRepository {
  updateAgents(agents: Agent[]): Promise<void>;
}

export interface TeammateAvailabilityChangedEventPublisher {
  publish(): Promise<void>;
}

export interface TeammateAvailabilityChangedUsecase
  extends BaseUsecase<TeammateAvailabilityChangePayload, void> {
  run(req: TeammateAvailabilityChangePayload): Promise<void>;
}

export class TeammateAvailabilityChanged
  implements TeammateAvailabilityChangedUsecase
{
  constructor(
    private repository: TeammateAvailabilityChangedRepository,
    private publisher: TeammateAvailabilityChangedEventPublisher,
  ) {}

  async run(payload: TeammateAvailabilityChangePayload): Promise<void> {
    const AgentListRepository = RepositoryFactory.buildMemAgentRepository();
    const agents = await AgentListRepository.getAgents();
    const updatedAgents = agents.map((agent: Agent) =>
      String(agent.ID).trim() === String(payload.userId).trim()
        ? {
            ...agent,
            isAvailable: payload.status === 'available' ? true : false,
            status: payload.status === 'available' ? 'available' : 'offline',
          }
        : agent,
    );
    this.repository.updateAgents(updatedAgents); // Call the getAgents method on the repository.

    await Promise.all([this.publisher.publish()]);
  }
}
